import { UserRole } from '../enums';

export interface User {
  id: string;
  email: string;
  passwordHash: string;
  role: UserRole;
  emailVerifiedAt: Date | null;
  accountStatus: 'active' | 'deactivated' | 'pending_deletion';
  createdAt: Date;
  updatedAt: Date;
}

import type { ProfilePrompts } from './user-settings';

export interface UserProfile {
  id: string;
  userId: string;
  username: string | null;
  displayName: string | null;
  avatarUrl: string | null;
  bannerUrl: string | null;
  bio: string | null;
  headline: string | null;
  topics: string[];
  profilePrompts: ProfilePrompts;
  location: string | null;
  websiteUrl: string | null;
  pinnedPostId: string | null;
  onboardingCompletedAt: Date | null;
}
